import { useContext } from "react"

import breakpointsContext, {
  BreakpointsContext,
} from "legacy/components/shared/BreakpointsProvider/BreakpointsContext"

const useBreakpoints = (): BreakpointsContext => useContext(breakpointsContext)

export default useBreakpoints
